export default __webpack_public_path__ + "static/media/IMG_7435.487ef2e2.jpg";